import { css } from '@mui/material/styles';
export const linkComponentOverrides = {
    MuiLink: {
        defaultProps: {
            variant: 'inherit'
        },
        styleOverrides: {
            root: ({ theme }) => css `
                color: ${theme.tokens.FuelColorTextLink};
                text-decoration-color: ${theme.tokens.FuelColorTextLink};

                &:hover {
                    color: ${theme.tokens.FuelColorTextLinkHovered};
                }

                &.Mui-focusVisible {
                    box-shadow: ${theme.tokens.FuelShadowFocused};
                    outline: none;
                }
            `
        }
    }
};
